export default __webpack_public_path__ + "static/media/01_DAIF_Data_02_02.36e3189c.mp4";